import Vue from 'vue'
import Vuex from 'vuex'
import {
    fnApiFetchHealthDeclarationAccess
} from '../../api/api-applications-health.js'

Vue.use(Vuex)


const actions = {
    postDeclaration(context, formDeclaration) {
        console.log(formDeclaration)
      return new Promise((resolve, reject) => {
        fnApiFetchHealthDeclarationAccess(formDeclaration)
            .then(response => {
                
                resolve(response)
            })
            .catch(error => {
                
                reject(error)
            })
      })
    }
  }

export default new Vuex.Store({
    namespaced: true,
    actions,
})
